import React, { useState } from "react";
import {
  Stop,
  Label,
  LabelEntityType,
  UserRoleType,
} from "@api/graphql/generated/generated-types";
import { LabelBadge } from "@src/common/components/LabelManagement/components/LabelBadge";
import { LabelAssignmentPopover } from "@src/common/components/LabelManagement/components/LabelAssignmentPopover";
import StopCard from "@src/common/components/StopCard/StopCard";
import { useAuth } from "@src/common/hooks/useAuth";

interface StopLabelSectionProps {
  stop: Stop;
  labelsData: Label[];
  labelsLoading: boolean;
  labelsError: any;
  onLabelAssignmentChanged: (res: any) => void;
  onLabelCreated: () => void;
}

export function StopLabelSection({
  stop,
  labelsData,
  labelsLoading,
  labelsError,
  onLabelAssignmentChanged,
  onLabelCreated,
}: StopLabelSectionProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { isRoleType } = useAuth();

  const assignedLabels = stop.assignedLabels || [];

  return (
    <div className="border-b border-gray-200 dark:border-gray-700 py-4 flex items-start gap-6">
      {/* Stop Information Column */}
      <div className="flex-1 min-w-0">
        <StopCard stop={stop} />
      </div>

      {/* Labels Column */}
      <div className="flex-1 min-w-0">
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
              Labels
            </span>
            {isRoleType(UserRoleType.Administrator) && (
              <LabelAssignmentPopover
                entityId={stop.id}
                selectedLabels={assignedLabels}
                isPopoverOpen={isPopoverOpen}
                onOpenPopover={() => setIsPopoverOpen(true)}
                onClosePopover={() => setIsPopoverOpen(false)}
                onLabelAssignmentChanged={onLabelAssignmentChanged}
                onLabelCreated={onLabelCreated}
                entityType={LabelEntityType.Stop}
                labelsData={labelsData}
                labelsLoading={labelsLoading}
                labelsError={labelsError}
                zIndex={100}
              />
            )}
          </div>

          <div className="flex flex-wrap gap-1 min-h-[32px]">
            {assignedLabels.length === 0 ? (
              <div className="text-gray-500 dark:text-gray-400 text-sm">
                No labels assigned
              </div>
            ) : (
              assignedLabels.map((label) => (
                <LabelBadge
                  key={label.id}
                  label={label}
                  onClick={() => setIsPopoverOpen(true)}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
